export default "__VITE_ASSET__CG7Uumxs__"